import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormCalculateServiceInspectionMileageActionParams {
  form: UseFormReturn<BaseVehicle>;
  value: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next service inspection mileage.
 * Uses the last service inspection mileage and service inspection interval to calculate the next mileage.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance
 */
export const formCalculateServiceInspectionMileageAction = (
  _context: unknown,
  params: FormCalculateServiceInspectionMileageActionParams
): void => {
  const {form, value} = params;

  const lastServiceInspectionMileage = value;
  const serviceInspectionAfterMileage = form.getValues(
    `serviceIntervals.serviceInspection.replacementAfterMileage`
  );

  if (!lastServiceInspectionMileage || !serviceInspectionAfterMileage) {
    return;
  }

  const nextMileage = lastServiceInspectionMileage + serviceInspectionAfterMileage;
  form.setValue(
    `serviceIntervals.serviceInspection.nextServiceInspectionMileage`,
    nextMileage,
    DEFAULT_OPTIONS
  );
};
